import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'verificationCode',
  standalone: true,
})
export class VerificationCodePipe implements PipeTransform {
  public transform(value: string): boolean {
    return value ? /^\d{6}$/.test(value) : null;
  }
}
